import { Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { generalReportsServices } from "api/services"
import { MainLoader } from "components/Loader/Loader"
import Template from "components/Template/Template"
import FileSaver from 'file-saver';
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store/store";
import * as serviceActions from 'store/ducks/services/actions';
import { IResPracticeByCategory } from "api/services/general-reports/types";
import VEHICLE_TYPES from "references/vehicle-types";




const PracticalExamStatisticByCategory: React.FC = () => {

  const [data, setData] = useState<IResPracticeByCategory[]>()
  const [calc, setCalc] = useState<any>()
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [hasError, setHasError] = useState(false)
  const [loading, setLoading] = useState(false)
  const { branches } = useSelector(
    (state: AppState) => state.services
  );
  const dispatch = useDispatch()

  useEffect(() => {
    getServices()
    getData()
  }, [])

  const getServices = () => {
    if (!branches.length) dispatch(serviceActions.getBranches());
  };

  const getData = async () => {
    let validation = true;

    if (!startDate.trim() || !endDate.trim()) {
      validation = false;
    }

    if (!validation) {
      setHasError(true);
      return;
    }

    const params = {
      startDate,
      endDate
    }
    const res = await generalReportsServices.getPracticalStatisticByVehicleType(params).then((res) => res.data)
    const data = res
    const result = [];

    const grouped = {} as any;

    for (const item of data) {
      const type = item.vehicle_type;

      if (!grouped[type]) {
        grouped[type] = {
          vehicle_type: type,
          total_practice_passed: 0,
          total_practice_count: 0,
        };
      }

      grouped[type].total_practice_passed += Number(item.practice_passed);
      grouped[type].total_practice_count += Number(item.practice_count);
    }

    // Преобразуем в массив с вычисленным процентом
    for (const key in grouped) {
      const entry = grouped[key];
      const { total_practice_passed, total_practice_count } = entry;

      const percent =
        total_practice_count === 0
          ? 0
          : (total_practice_passed * 100) / total_practice_count;

      result.push({
        vehicle_type: key,
        total_practice_passed: total_practice_passed.toString(),
        total_practice_count: total_practice_count.toString(),
        percent: percent.toFixed(2), // округление до 2 знаков
      });
    }
    setCalc(result)
    setData(res)
  }

  const exportFile = async () => {
    const params = {
      startDate,
      endDate
    }
    const res = await generalReportsServices.getPracticalStatisticByVehicleTypeFile(params).then((res) => res.data)
    const blob = new Blob(['\ufeff', res], { type: 'text/csv' });
    FileSaver.saveAs(blob, 'filename.csv');
  }


  const clearHandler = () => {
    setStartDate('');
    setEndDate('');
  };

  return (
    <Template>
      <div className="practical-exam-statistic-by-category">
        <Typography variant='h3' className='statistics-report-page__title'>
          Статистика ПЭ по категориям
        </Typography>
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item md={2.5}>
            <TextField
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              label='По'
              autoComplete='off'
              variant='outlined'
              size='small'
              type='date'
              InputLabelProps={{ shrink: true }}
              error={hasError && !startDate.trim()}
            />
          </Grid>
          <Grid item md={2.5}>
            <TextField
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              label='По'
              autoComplete='off'
              variant='outlined'
              size='small'
              type='date'
              InputLabelProps={{ shrink: true }}
              error={hasError && !endDate.trim()}
            />
          </Grid>
          <Grid item md={1.5}>
            <Button
              variant='contained'
              color='success'
              className='reports-for-school__button'
              disabled={loading}
              onClick={getData}
            >
              {loading ? <MainLoader></MainLoader> : ' ОТЧЕТ'}
            </Button>
          </Grid>
          <Grid item md={1.5}>
            <Button
              variant='contained'
              color='info'
              className='reports-for-school__button'
              disabled={loading}
              onClick={exportFile}
            >
              {loading ? <MainLoader></MainLoader> : 'ЭКСПОРТ'}
            </Button>
          </Grid>
          <Grid item md={1.5}>
            <Button
              variant='contained'
              color='error'
              className='reports-for-school__button'
              onClick={clearHandler}
            >
              Очистить
            </Button>
          </Grid>
        </Grid>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Категория Т/С</TableCell>
                {branches?.map((i) => (
                  <TableCell key={i.id}>{i.nameRu}</TableCell> 
                ))}
                <TableCell>Итого</TableCell>
                <TableCell>Процент сдачи</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {VEHICLE_TYPES?.map((i, index) => (
                <React.Fragment key={index}>
                  <TableRow >
                    <TableCell>{i.value}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Ташкент' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Ахангаран' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Фергана' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Андижан' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Гулистан' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Жиззах' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Наманган' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Карши' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Самарканд' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Бухара' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Навои' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Нукус' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Термез' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Ургент' && ii.vehicle_type === i.value)?.practice_count || 0}</TableCell>
                    <TableCell>{calc?.find((ii: any) => ii.vehicle_type === i.value)?.total_practice_count || 0}</TableCell>
                    <TableCell rowSpan={2}>{calc?.find((ii: any) => ii.vehicle_type === i.value)?.percent || 0}%</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Успешно</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Ташкент' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Ахангаран' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Фергана' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Андижан' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Гулистан' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Жиззах' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Наманган' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Карши' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Самарканд' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Бухара' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Навои' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Нукус' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Термез' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{data?.find((ii) => ii.name_ru === 'Ургент' && ii.vehicle_type === i.value)?.practice_passed || 0}</TableCell>
                    <TableCell>{calc?.find((ii: any) => ii.vehicle_type === i.value)?.total_practice_passed || 0}</TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    </Template>
  )
}

export default PracticalExamStatisticByCategory